export enum HawkEvents {
  HAWK_PROCESS_ARTICLE = 'processArticle',
  HAWK_URL_CHANGE = 'HAWK_URL_CHANGE',
}
